import { Component, OnInit, Input, ViewChildren, ViewContainerRef, ViewChild, AfterViewInit, QueryList, Output, EventEmitter } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { ChartService } from '../../services/chart.service';

@Component({
    selector: 'app-composite-chart',
    templateUrl: './composite-chart.component.html',
    styleUrls: ['./composite-chart.component.scss'],
    standalone: false
})
export class CompositeChartComponent implements OnInit, AfterViewInit {
  @Input() data: any;
  selectedWidget: any;
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  widgetArray: any[] = [];

  constructor(private baseService: BaseService,private loader:LoaderService, public chartService: ChartService,) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.chartService.getWidget(this.data,(res)=>{
      this.data = res.data;
      this.selectedWidget = this.data.composite_data[0].widget_name
      this.createWidget(this.data.composite_data[0])
    });
  }
  createWidget(nav) {
    this.loader.showSpinner()
    if(this.customComponent)
    this.customComponent.clear()
    this.baseService.getById(nav.widget_id, 'widget_config', 'account-management').subscribe(res => {
      // this.widgetArray.push(res)
      this.baseService.createComponent(res.selector, this.customComponent, (response) => {
        response.instance.data = nav;
        response.instance.hideLabels = true;
        response.changeDetectorRef.detectChanges();
        this.loader.hideSpinner()
      });
    })
    this.selectedWidget = nav.widget_name
  }
}


